import { render, staticRenderFns } from "./__order_channel.vue?vue&type=template&id=41c29202&"
import script from "./__order_channel.vue?vue&type=script&lang=js&"
export * from "./__order_channel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports